<div class="container-fluid container-xxl gx-0 my-13">
    <div>
        <div class="col-md-8 mx-auto col-11 fs-md-15 fs-14">
            <h5 class="text-center fw-700">{{ 'COOKIES_POLICY.title' | translate }}</h5>
            <p class="text-start">
                {{ 'COOKIES_POLICY.description' | translate }}
                <a [routerLink]="['/'] | localize">{{ currentDomain }}</a>
            </p>
            <h5 class="text-start fw-700 mt-10">{{ 'COOKIES_POLICY.CHAPTER-1.title' | translate }}</h5>
            <div class="mt-8 row">
                <span class="col-1 text-end">{{ 'NUMBERS.1.' | translate }}</span>
                <p class="col-11">
                    {{ 'COOKIES_POLICY.CHAPTER-1.SUB-CHAPTER-1.title' | translate }}
                </p>
            </div>
            <div class="mt-2 row">
                <span class="col-1 text-end">{{ 'NUMBERS.2.' | translate }}</span>
                <p class="col-11">
                    {{ 'COOKIES_POLICY.CHAPTER-1.SUB-CHAPTER-2.title' | translate }}
                </p>
            </div>
            <div class="mt-2 row">
                <span class="col-1 text-end">{{ 'NUMBERS.3.' | translate }}</span>
                <p class="col-11">
                    {{ 'COOKIES_POLICY.CHAPTER-1.SUB-CHAPTER-3.title' | translate }}
                </p>
            </div>
            <div class="mt-2 row">
                <span class="col-1 text-end">{{ 'NUMBERS.4.' | translate }}</span>
                <p class="col-11">
                    {{ 'COOKIES_POLICY.CHAPTER-1.SUB-CHAPTER-4.title' | translate }}
                </p>
            </div>
            <div class="mt-2 row">
                <span class="col-1 text-end">{{ 'NUMBERS.5.' | translate }}</span>
                <p class="col-11">
                    {{ 'COOKIES_POLICY.CHAPTER-1.SUB-CHAPTER-5.title' | translate }}
                </p>
            </div>

            <h5 class="text-start fw-700 mt-8">{{ 'COOKIES_POLICY.CHAPTER-2.title' | translate }}</h5>
            <div class="mt-8 row">
                <span class="col-1 text-end">{{ 'NUMBERS.1.' | translate }}</span>
                <p class="col-11">
                    {{ 'COOKIES_POLICY.CHAPTER-2.SUB-CHAPTER-1.title' | translate }}
                </p>
            </div>
            <div class="mt-2 row">
                <span class="col-1 text-end">{{ 'NUMBERS.2.' | translate }}</span>
                <div class="col-11">
                    <p>
                        {{ 'COOKIES_POLICY.CHAPTER-2.SUB-CHAPTER-2.title' | translate }}
                    </p>
                    <div class="mt-2 ms-2 row">
                        <span class="col-1 text-end">{{ 'LETTERS.a)' | translate }}</span>
                        <p class="col-11">{{ 'COOKIES_POLICY.CHAPTER-2.SUB-CHAPTER-2.SUB-SECTION-1.title' | translate }}</p>
                    </div>
                    <div class="mt-2 ms-2 row">
                        <span class="col-1 text-end">{{ 'LETTERS.b)' | translate }}</span>
                        <p class="col-11">{{ 'COOKIES_POLICY.CHAPTER-2.SUB-CHAPTER-2.SUB-SECTION-2.title' | translate }}</p>
                    </div>
                </div>
            </div>
            <div class="mt-2 row">
                <span class="col-1 text-end">{{ 'NUMBERS.3.' | translate }}</span>
                <p class="col-11">
                    {{ 'COOKIES_POLICY.CHAPTER-2.SUB-CHAPTER-3.title' | translate }}
                </p>
            </div>
            <h5 class="text-start fw-700 mt-8">{{ 'COOKIES_POLICY.CHAPTER-3.title' | translate }}</h5>
            <div class="mt-8 row">
                <p>{{ 'COOKIES_POLICY.CHAPTER-3.description' | translate }}</p>
                <div class="mt-2 row">
                    <span class="col-1 text-end">{{ 'NUMBERS.1.' | translate }}</span>
                    <div class="col-11">
                        <p>
                            {{ 'COOKIES_POLICY.CHAPTER-3.SUB-CHAPTER-1.title' | translate }}
                        </p>
                        <div class="mt-2 ms-2 row">
                            <span class="col-1 text-end">{{ 'LETTERS.a)' | translate }}</span>
                            <p class="col-11">{{ 'COOKIES_POLICY.CHAPTER-3.SUB-CHAPTER-1.SUB-SECTION-1.title' | translate }}</p>
                        </div>
                        <div class="mt-2 ms-2 row">
                            <span class="col-1 text-end">{{ 'LETTERS.b)' | translate }}</span>
                            <p class="col-11">{{ 'COOKIES_POLICY.CHAPTER-3.SUB-CHAPTER-1.SUB-SECTION-2.title' | translate }}</p>
                        </div>
                        <div class="mt-2 ms-2 row">
                            <span class="col-1 text-end">{{ 'LETTERS.c)' | translate }}</span>
                            <p class="col-11">{{ 'COOKIES_POLICY.CHAPTER-3.SUB-CHAPTER-1.SUB-SECTION-3.title' | translate }}</p>
                        </div>
                    </div>
                </div>

                <div class="mt-2 row">
                    <span class="col-1 text-end">{{ 'NUMBERS.2.' | translate }}</span>
                    <p class="col-11">
                        {{ 'COOKIES_POLICY.CHAPTER-3.SUB-CHAPTER-2.title' | translate }}
                    </p>
                </div>
            </div>
            <h5 class="text-start fw-700 mt-8">{{ 'COOKIES_POLICY.CHAPTER-4.title' | translate }}</h5>
            <div class="mt-8 row">
                <span class="col-1 text-end">{{ 'NUMBERS.1.' | translate }}</span>
                <div class="col-11">
                    <p>
                        {{ 'COOKIES_POLICY.CHAPTER-4.SUB-CHAPTER-1.title-1' | translate }}
                        <br /><br />
                        {{ 'COOKIES_POLICY.CHAPTER-4.SUB-CHAPTER-1.title-2' | translate }}
                    </p>

                    <div class="mt-2 row">
                        <span class="col-1 text-end">{{ 'LETTERS.a)' | translate }}</span>
                        <p class="col-11">
                            {{ 'COOKIES_POLICY.CHAPTER-4.browser' | translate }}
                            <a href="http://windows.microsoft.com/pl-PL/windows7/How-to-manage-cookies-in-Internet-Explorer-9" target="_blank">{{
                                'COOKIES_POLICY.CHAPTER-4.internet_explorer' | translate
                            }}</a>
                        </p>
                    </div>
                    <div class="mt-2 row">
                        <span class="col-1 text-end">{{ 'LETTERS.b)' | translate }}</span>
                        <p class="col-11">
                            {{ 'COOKIES_POLICY.CHAPTER-4.browser' | translate }}
                            <a href="http://support.mozilla.org/pl/kb/ciasteczka" target="_blank">{{
                                'COOKIES_POLICY.CHAPTER-4.mozilla_firefox' | translate
                            }}</a>
                        </p>
                    </div>
                    <div class="mt-2 row">
                        <span class="col-1 text-end">{{ 'LETTERS.c)' | translate }}</span>
                        <p class="col-11">
                            {{ 'COOKIES_POLICY.CHAPTER-4.browser' | translate }}
                            <a href="http://support.google.com/chrome/bin/answer.py?hl=pl&answer=95647" target="_blank">{{
                                'COOKIES_POLICY.CHAPTER-4.chrome' | translate
                            }}</a>
                        </p>
                    </div>
                    <div class="mt-2 row">
                        <span class="col-1 text-end">{{ 'LETTERS.d)' | translate }}</span>
                        <p class="col-11">
                            {{ 'COOKIES_POLICY.CHAPTER-4.browser' | translate }}
                            <a href="http://support.apple.com/kb/HT1677?viewlocale=pl_PL&locale=pl_PL" target="_blank">{{
                                'COOKIES_POLICY.CHAPTER-4.safari' | translate
                            }}</a>
                        </p>
                    </div>
                    <div class="mt-2 row">
                        <span class="col-1 text-end"> {{ 'LETTERS.e)' | translate }} </span>
                        <p class="col-11">
                            {{ 'COOKIES_POLICY.CHAPTER-4.browser' | translate }}
                            <a href="http://help.opera.com/Linux/9.22/pl/cookies.html" target="_blank">{{ 'COOKIES_POLICY.CHAPTER-4.opera' | translate }}</a>
                        </p>
                    </div>
                </div>
                <div class="mt-2 row">
                    <span class="col-1 text-end">{{ 'NUMBERS.2.' | translate }}</span>
                    <p class="col-11">
                        {{ 'COOKIES_POLICY.CHAPTER-4.SUB-CHAPTER-2.title' | translate }}
                    </p>
                </div>
                <div class="mt-2 row">
                    <span class="col-1 text-end">{{ 'NUMBERS.3.' | translate }}</span>
                    <p class="col-11">
                        {{ 'COOKIES_POLICY.CHAPTER-4.SUB-CHAPTER-3.title' | translate }}
                    </p>
                </div>
            </div>
        </div>
    </div>
</div>
